export default "__VITE_ASSET__DTzg4WWO__"